<div class="footer pv-8">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 col-md-5 pv-8">
        <span> &copy; 2020 - {{year}}, Labrador</span>
      </div>
      <div class="col-xs-12 col-md-7 pv-8">
        <div class="footerLink">
          <a class="elink mh-15" routerLink="">Home</a>
          <a class="elink mh-15" routerLink="/info/faqs">FAQS</a>
          <a class="elink mh-15" target="_blank" href="https://www.thelabrador.co.uk/privacy-notice">Privacy</a>
          <a class="elink ml-15" target="_blank" href="https://www.thelabrador.co.uk/termsconditions">T&C</a>
        </div>
      </div>
    </div>
  </div>
</div>